/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListOrganizationUsersDto
 */
export interface ListOrganizationUsersDto {
    /**
     * 
     * @type {string}
     * @memberof ListOrganizationUsersDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ListOrganizationUsersDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ListOrganizationUsersDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListOrganizationUsersDto
     */
    roleId: string;
    /**
     * 
     * @type {string}
     * @memberof ListOrganizationUsersDto
     */
    roleName: string;
    /**
     * 
     * @type {string}
     * @memberof ListOrganizationUsersDto
     */
    language: ListOrganizationUsersDtoLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof ListOrganizationUsersDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ListOrganizationUsersDto
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListOrganizationUsersDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ListOrganizationUsersDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ListOrganizationUsersDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const ListOrganizationUsersDtoLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type ListOrganizationUsersDtoLanguageEnum = typeof ListOrganizationUsersDtoLanguageEnum[keyof typeof ListOrganizationUsersDtoLanguageEnum];


/**
 * Check if a given object implements the ListOrganizationUsersDto interface.
 */
export function instanceOfListOrganizationUsersDto(value: object): value is ListOrganizationUsersDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('roleId' in value) || value['roleId'] === undefined) return false;
    if (!('roleName' in value) || value['roleName'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ListOrganizationUsersDtoFromJSON(json: any): ListOrganizationUsersDto {
    return ListOrganizationUsersDtoFromJSONTyped(json, false);
}

export function ListOrganizationUsersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOrganizationUsersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'name': json['name'],
        'roleId': json['roleId'],
        'roleName': json['roleName'],
        'language': json['language'],
        'organizationId': json['organizationId'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'active': json['active'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ListOrganizationUsersDtoToJSON(json: any): ListOrganizationUsersDto {
    return ListOrganizationUsersDtoToJSONTyped(json, false);
}

export function ListOrganizationUsersDtoToJSONTyped(value?: ListOrganizationUsersDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
        'roleId': value['roleId'],
        'roleName': value['roleName'],
        'language': value['language'],
        'organizationId': value['organizationId'],
        'phone': value['phone'],
        'active': value['active'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

